
import { CCB } from "../../../openapi/ccb"

export type CCBState = {
    searchDone: boolean,
    error? : string,
    ccbs?: CCB[],
    ccbSearchCriteria?: FormData
}

export  type CCBAction =
    | {
      type: "CCB/SEARCHDONE",
      payload: CCB[],
      searchCriteria: FormData
    }
    | {
        type: "CCB/RESETSEARCH"
    }
    | {
        type: "CCB/FETCHERROR",
        payload: string
    }
  
const initialState: CCBState = { searchDone: false }

export const ccbReducer = (
        state: CCBState = initialState,
        action: CCBAction 
    ) => {
        switch (action.type) {
            case "CCB/SEARCHDONE":
              return { ...state,  searchDone: true, ccbs: action.payload, ccbSearchCriteria: action.searchCriteria }
            case "CCB/RESETSEARCH" : {
                return { ...state,  searchDone: false }
            }
            case "CCB/FETCHERROR" : {
                return { ...state,  searchDone: false, error: action.payload }
            }
            default: return state
        }
    }
    